import { configureStore } from "@reduxjs/toolkit";
import rootReducers from "../actions/reducers/rootReducers";

export default configureStore({
  reducer: rootReducers,
  // middleware: [thunkMiddleWare] is not needed unless you have additional middleware
});
